<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
    <div class="container">
      <router-link class="navbar-brand fw-bold text-primary" to="/landing">
        <i class="bi bi-journal-text me-2"></i>Zals Notes
      </router-link>
      <button 
        class="navbar-toggler border-0" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarSupportedContent" 
        aria-controls="navbarSupportedContent" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/landing">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" active-class="active" to="/about">About</router-link>
          </li>
        </ul>
                <div class="d-flex align-items-center gap-2">
                  <button class="btn btn-link nav-link p-0 me-3" @click="toggleTheme" title="Toggle Theme">
                     <i class="bi" :class="theme === 'light' ? 'bi-moon-stars-fill' : 'bi-sun-fill'" style="font-size: 1.2rem;"></i>
                  </button>
                  <button class="btn btn-outline-danger btn-sm rounded-pill px-4" v-on:click="logout">
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </template>
        
        <script>
        import { authnya } from '../firebase.js'
        import { inject } from 'vue'
        
        export default {
          name: 'Header',
          setup() {
            const theme = inject('theme')
            const toggleTheme = inject('toggleTheme')
            return { theme, toggleTheme }
          },
          methods: {
            logout() {
              authnya.signOut()
              this.$router.push('/')
            }
          }
        }
        </script>
        
        <style scoped>
        .navbar-brand {
          font-size: 1.5rem;
          letter-spacing: -0.5px;
        }
        .nav-link {
          font-weight: 500;
          color: var(--text-main);
          margin-right: 1rem;
        }
        .nav-link:hover {
           color: #4a90e2;
        }
        .nav-link.active {
          color: #4a90e2 !important;
        }
        
        /* Header specific overrides */
        .navbar {
          background-color: var(--card-bg) !important;
          transition: background-color 0.3s ease;
        }
        .navbar-light .navbar-brand {
          color: var(--text-main);
        }
        .navbar-light .navbar-nav .nav-link {
          color: var(--text-main);
        }
        </style>
        